import React,{Component} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

class VoidFormReason extends Component {

    state={
        text:""
    }
    render() {
        return <Dialog onClose={this.props.onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" open={true}
        >
        <DialogTitle id="alert-dialog-title">Indicate a reason to void the form</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>You are going to delete a form that has already been sent to the user, please use the form below to enter the reason why the form is being deleted.</p>
            <div className="form-group">
                <textarea className="form-control" rows={2} onChange={(e)=>this.setState({text:e.target.value})} value={this.state.text} />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" disabled={!this.state.text} onClick={()=>this.props.onConfirm(this.state.text)} color="primary" autoFocus>
           Confirm Deletion
          </Button>
          <Button onClick={this.props.onCancel} color="primary">
            Cancel
          </Button>
        </DialogActions>
        </Dialog>;
    }
}
export default VoidFormReason;